import React, { FC } from 'react';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
// Components
import {
  FormLabel,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  IconButton
} from '@mui/material';
import { ExpandMore, Edit, Delete, RecentActors } from '@mui/icons-material';
// Types
import { IAttorneyOffice } from '../../../models';

interface IMobileAttorneyOffice {
  original: IAttorneyOffice;
  handleEdit: (val: IAttorneyOffice) => void;
  handleDelete: (val: IAttorneyOffice) => void;
  handleEditUsers: (val: IAttorneyOffice) => void;
}

export const MobileAttorneyOffice: FC<IMobileAttorneyOffice> = ({
  original,
  handleEdit,
  handleDelete,
  handleEditUsers
}) => {
  const classes = useStyles();
  const { workplace } = original;

  return (
    <Accordion className={classes.root}>
      <AccordionSummary
        className={classes.accordion}
        expandIcon={<ExpandMore />}
        aria-controls="panel1a-content"
        id="panel1a-header"
      >
        <div className={classes.topPanelSummaryWrapper}>
          <Typography variant="body2">{workplace}</Typography>
          <div className={classes.buttonsWrapper}>
            <IconButton
              className={classes.editButton}
              color="secondary"
              onClick={e => {
                e.stopPropagation();
                handleEditUsers(original);
              }}
              size="large"
            >
              <RecentActors />
            </IconButton>
            <IconButton
              className={classes.editButton}
              color="primary"
              onClick={e => {
                e.stopPropagation();
                handleEdit(original);
              }}
              size="large"
            >
              <Edit />
            </IconButton>
            <IconButton
              className={classes.deleteButton}
              color="default"
              onClick={e => {
                e.stopPropagation();
                handleDelete(original);
              }}
              size="large"
            >
              <Delete />
            </IconButton>
          </div>
        </div>
      </AccordionSummary>
      <AccordionDetails className={classes.details}>
        <div className={classes.panelSummaryWrapper}>
          <FormLabel component="span" className={clsx(classes.boldName, classes.subLabel)}>
            Workplace:
          </FormLabel>
          <Typography component="span">{workplace || '--'}</Typography>
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    maxWidth: '100%',
    border: `1px solid ${theme.palette.grey[300]}`,
    overflowX: 'hidden'
  },
  accordion: {
    padding: '0 16px',
    '&& .MuiAccordionSummary-expandIcon': {
      padding: 3
    }
  },
  topPanelSummaryWrapper: {
    marginTop: theme.spacing(0.5),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    '&:first-child': { marginTop: 0 }
  },
  panelSummaryWrapper: {
    '&:first-child': { marginTop: 0 }
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    padding: '12px 16px',
    backgroundColor: theme.palette.grey[100]
  },
  roleWrapper: {
    display: 'flex',
    alignItems: 'center'
  },
  editButton: {
    padding: `2px 5px`
  },
  deleteButton: {
    padding: `2px 5px`,
    color: theme.palette.error.main
  },
  boldName: {
    color: theme.palette.typography.labels,
    fontWeight: 600
  },
  subLabel: {
    marginRight: 10,
    fontSize: theme.typography.body2.fontSize
  },
  buttonsWrapper: {
    display: 'flex'
  }
}));
